var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.navigator && _vm.navigator.share)?_c('button',{staticClass:"button",on:{"click":function($event){try {
      _vm.navigator.share({title: _vm.title, text: _vm.description, url: _vm.url});
    } catch(err) {
      if(! _vm.isShareCancelledError(_vm.err)) {
        throw _vm.err;
      }
    }}}},[_c('img',{staticClass:"w-16 pr-2",attrs:{"src":"/images/icons/share-violet.svg"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }